import { Component } from '@angular/core';

@Component({
  selector: 'app-buildings-router',
  template: '<router-outlet></router-outlet>'
})

export class BuildingsRouterComponent { }



// WEBPACK FOOTER //
// ./src/app/buildings/buildings-router.component.ts